/**
 * Better Auth client for the dashboard SPA.
 *
 * Hits the worker at api.pfh.trading (prod) or :8787 (dev). The session
 * cookie is set cross-subdomain by the landing worker on `.pfh.trading`,
 * so requests from app.pfh.trading carry it automatically.
 *
 * The dashboard SPA never minted its own sessions — login is at
 * pfh.trading/login. We only consume the session here.
 */

import { createAuthClient } from "better-auth/react";

const baseURL = import.meta.env.DEV
  ? "http://localhost:8787"
  : "https://api.pfh.trading";

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    // Required so the cross-subdomain cookie is sent on cross-origin
    // requests from app.pfh.trading → api.pfh.trading.
    credentials: "include",
  },
});

export const { useSession, signOut } = authClient;
